import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TabsContent } from "@/components/ui/tabs";
import { HelpCircle } from "lucide-react";
import { useState } from "react";
import type { UseFieldArrayReturn, UseFormReturn } from "react-hook-form";
import type { UserFormValues } from "./form";

interface UserVehiclesTabProps {
  form: UseFormReturn<UserFormValues>;
  fields: UseFieldArrayReturn<UserFormValues, "vehicles">["fields"];
}

const UserVehiclesTab = ({ fields, form }: UserVehiclesTabProps) => {
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = (checked: boolean) => {
    setSelectAll(checked);

    const newPermissionValue = checked ? 26 : 0;

    fields.forEach((_, index) => {
      form.setValue(`vehicles.${index}.permission`, newPermissionValue);
    });
  };

  return (
    <TabsContent value="vehicles" className="space-y-6 mt-4">
      <div className="space-y-4">
        <div className="p-4 rounded-md">
          <label htmlFor="">Permitir tudo</label>
          <Switch
            id="select-all"
            className="ml-2 bg-foreground"
            checked={selectAll}
            onCheckedChange={handleSelectAll}
          />
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Veículo</TableHead>
                <TableHead>Monitorar</TableHead>
                <TableHead>
                  <div className="flex items-center gap-1 relative group">
                    Atuadores
                    <HelpCircle className="h-4 w-4 text-muted-foreground cursor-help" />
                    <div className="absolute z-10 invisible group-hover:visible bg-black text-white text-xs rounded p-2 -right-4 top-6 w-64 shadow-lg">
                      Permissão para utilizar os atuadores instalados no
                      veículo, como bloqueio, acionamento de travas, sirene, etc
                    </div>
                  </div>
                </TableHead>
                <TableHead>Configurar</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {fields.map((field, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {field.plate} - {field.title}
                  </TableCell>
                  <TableCell>
                    <FormField
                      control={form.control}
                      name={`vehicles.${index}.permission`}
                      render={({ field: { value = 0, onChange } }) => (
                        <FormItem>
                          <FormControl>
                            <Switch
                              className="bg-foreground"
                              checked={!!(value & 2)}
                              onCheckedChange={(checked) =>
                                onChange(checked ? value | 2 : value & ~2)
                              }
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <FormField
                      control={form.control}
                      name={`vehicles.${index}.permission`}
                      render={({ field: { value = 0, onChange } }) => (
                        <FormItem>
                          <FormControl>
                            <Switch
                              className="bg-foreground"
                              checked={!!(value & 8)}
                              onCheckedChange={(checked) =>
                                onChange(checked ? value | 8 : value & ~8)
                              }
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <FormField
                      control={form.control}
                      name={`vehicles.${index}.permission`}
                      render={({ field: { value = 0, onChange } }) => (
                        <FormItem>
                          <FormControl>
                            <Switch
                              className="bg-foreground"
                              checked={!!(value & 16)}
                              onCheckedChange={(checked) =>
                                onChange(checked ? value | 16 : value & ~16)
                              }
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </TabsContent>
  );
};

export default UserVehiclesTab;
